export default "__VITE_ASSET__KZR1F5nG__"